import {
  Payment as DataPayment,
  PaymentFragment,
  PaymentData,
  Brand,
} from 'data/types/payment';
import formatPriceNumber from 'utils/formatPrice';

const normalizeBrand = (data: Brand) => ({
  name: data.name,
  image: {
    src: data.logo,
    alt: `${data.name} logo`,
  },
});

export const normalizePaymentItemFragment = (data: PaymentFragment) => ({
  integrationId: data.integrationId,
  subtotal: formatPriceNumber(data.subtotal),
  tax: formatPriceNumber(data.tax),
  platformPayout: formatPriceNumber(data.platformPayout),
  net: formatPriceNumber(data.net),
  comments: data.comment,
});

export const normalizePaymentItem = (data: DataPayment) => ({
  subtotal: formatPriceNumber(data.totalSubtotal),
  tax: formatPriceNumber(data.totalTax),
  total: formatPriceNumber(data.totalPlatform),
  netPayout: formatPriceNumber(data.totalNet),
  brandName: normalizeBrand(data.brandName),
  comments: data.comment,
  integrations: data.integrations.map(normalizePaymentItemFragment),
});

export const normalizePayment = (data: PaymentData) => ({
  payments: data.payments.map(normalizePaymentItem),
});

export type Payment = ReturnType<typeof normalizePayment>;
export type PaymentItem = ReturnType<typeof normalizePaymentItem>;
export type PaymentItemFragment = ReturnType<
  typeof normalizePaymentItemFragment
>;
